import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { AccountService } from '../../account.service';
import { StripeSearchOptions } from 'src/app/shared/models/stripe/stripe-search-options';
import { StripeCustomerData } from 'src/app/shared/models/stripe/stripe-customer-data';
import { PaymentMethod } from '@stripe/stripe-js';
import { MatDialog } from '@angular/material/dialog';
import { StripeAddPaymentModalComponent } from 'src/app/shared/modals/stripe-add-payment-modal/stripe-add-payment-modal.component';
import { MessageModalComponent } from 'src/app/shared/modals/message-modal/message-modal.component';
import { StripeEditPaymentModalComponent } from 'src/app/shared/modals/stripe-edit-payment-modal/stripe-edit-payment-modal.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'my-account-payment-methods',
    templateUrl: './my-account-payment-methods.component.html',
    styleUrl: './my-account-payment-methods.component.scss',
    standalone: false
})
export class MyAccountPaymentMethodsComponent extends BaseComponent implements OnInit {
  private option: StripeSearchOptions = new StripeSearchOptions();
  public customer: StripeCustomerData = new StripeCustomerData();
  public paymentMethods: Array<PaymentMethod> = [];

  constructor(public sessionService: SessionService,
    public accountService: AccountService,
    private dialog: MatDialog,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
  }

  ngOnInit(): void {
    this.getCustomer();
  }

  getCustomer() {
    this.isLoading = true;
    this.option.query = `metadata['GolfTechId']:'${this.sessionService.getUserId()}'`;
    this.accountService.getStripeCustomer(this.option).subscribe({
      next: (result: any) => {
        this.customer = result.data[0];
        var k = 1;
      },
      error: (err) => {
        console.log(err);
        // show error message
      },
      complete: () => {
        this.getCustomerPaymentMethods();
      }
    });
  }

  getCustomerPaymentMethods() {
    this.accountService.getStripeCustomerPaymentMethods(this.customer.id).subscribe({
      next: (result: any) => {
        this.paymentMethods = result.data;
      },
      error: (err) => {
        console.log(err);
        // show error message
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  addPaymentMethod() {
    const paymentDialog = this.dialog.open(StripeAddPaymentModalComponent, {
      width: '45vw',
      disableClose: true
    });

    paymentDialog.componentInstance.customerId = this.customer.id;
    paymentDialog.componentInstance.isDefault = this.paymentMethods.length > 0 ? false : true;
    paymentDialog.componentInstance.isDefault = this.paymentMethods.length === 0 ? true : false;

    paymentDialog.afterClosed().subscribe(result => {
      if(result.message === "save"){
        this.getCustomer();
      }
    });
  }

  editPaymentMethod(paymentMethod) {
    const paymentDialog = this.dialog.open(StripeEditPaymentModalComponent, {
      width: '45vw',
      disableClose: true
    });

    paymentDialog.componentInstance.customerId = this.customer.id;
    paymentDialog.componentInstance.paymentMethodId = paymentMethod.id;
    paymentDialog.componentInstance.patchPaymentMethod(paymentMethod);
    paymentDialog.componentInstance.defaultPaymentMethod = this.customer.invoice_settings.default_payment_method === paymentMethod.id;


    paymentDialog.afterClosed().subscribe(result => {
      if(result == "save"){
        this.getCustomer();
      }
    });
  }


  deletePaymentMethod(id) {
    const messageDialog = this.dialog.open(MessageModalComponent, {
      width: '35vw',
    });

    if(this.customer.invoice_settings.default_payment_method === id){
      messageDialog.componentInstance.title = 'Cannot Delete Payment Method';
      messageDialog.componentInstance.body = `Unable to delete the Default Payment Method. Please assign a new Default Payment Method.`;
      messageDialog.componentInstance.okayButtonText = 'Close';
      messageDialog.componentInstance.isOtherButtonVisible = false;
    }else{
      messageDialog.componentInstance.title = 'Delete Payment';
      messageDialog.componentInstance.body = `Are you sure you want to delete this payment method? Once a payment method is deleted, it cannot be recoverd.`;
      messageDialog.componentInstance.okayButtonText = 'Yes';
      messageDialog.componentInstance.otherButtonText = 'No';
    }

    messageDialog.afterClosed().subscribe((result: string) => {
      if (result.toLocaleLowerCase() === 'yes') {
        this.accountService.deleteStripeCustomerPaymentMethod(id).subscribe(() => {
          this.getCustomer();
        }, err => {
          //show error message
        });
      }
    });
  }

}
